// Release Theme Lifecycle Hook
//
// Encapsulates the mount/unmount lifecycle that sets the release scope
// (`data-release`) on the document root. Used by each Release_Page.
//
// - On mount it performs a single atomic setAttribute (Requirement 4.6).
// - It never touches `data-theme`, so the light/dark selection (and
//   ThemeToggle) is untouched (Requirement 5).
// - The fallback warning is the "indication that no release-specific theme
//   exists" (Requirement 1.5).

import { useEffect } from 'react';
import { resolveReleaseTheme } from './releaseThemes';

export function useReleaseTheme(requestedId) {
  useEffect(() => {
    const { releaseId, isFallback } = resolveReleaseTheme(requestedId);
    if (isFallback) {
      console.warn(
        `[release-color-themes] No theme defined for release "${requestedId}". ` +
        `Falling back to "${releaseId}" light palette.`
      );
    }
    document.documentElement.setAttribute('data-release', releaseId);
    return () => {
      // Clear only if this page still owns the attribute.
      if (document.documentElement.getAttribute('data-release') === releaseId) {
        document.documentElement.removeAttribute('data-release');
      }
    };
  }, [requestedId]);
}
